export default __webpack_public_path__ + "img/1adfc44eb10ecb719878014cdff82b49.svg";